/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("FolderController", ["ControllerBase", "ControllerFactory"], function (context, cls) {
  /**
   * @class FolderController
   * @memberOf classes
   * @extends classes.ControllerBase
   */
  class FolderController extends cls.ControllerBase /** @lends classes.FolderController.prototype */ {
    static __name = "FolderController";

    _initBehaviors() {
      super._initBehaviors();

      // These behaviors should stay added at first
      // WARNING : DO NOT ADD BEHAVIORS BEFORE
      this._addBehavior(cls.LayoutInfoVMBehavior);
      this._addBehavior(cls.StyleVMBehavior);
      // END WARNING

      // 4st behaviors
      this._addBehavior(cls.TabPosition4STBehavior);
      this._addBehavior(cls.Reverse4STBehavior);

      // vm behaviors
      this._addBehavior(cls.HiddenVMBehavior);
      this._addBehavior(cls.BackgroundColorVMBehavior);
      this._addBehavior(cls.FontFamilyVMBehavior);
      this._addBehavior(cls.TitleVMBehavior);
      this._addBehavior(cls.CollapserPosition4STBehavior);
      this._addBehavior(cls.NoSwipeVMBehavior);
      this._addBehavior(cls.NavigationArrows4STBehavior);
      this._addBehavior(cls.NavigationDots4STBehavior);

      // ui behaviors
      this._addBehavior(cls.ChangePageUIBehavior);

      const layoutService = this.getAnchorNode().getApplication().layout;
      this._afterLayoutHandler = layoutService.afterLayout(this.onAfterLayout.bind(this));

      // Set rendering mode from 4ST (must be applied before childs insertion)
      const lateRendering = this.getAnchorNode().getStyleAttribute("lateRendering");
      if (lateRendering && this.getWidget().setLateRendering) {
        this.getWidget().setLateRendering(lateRendering === "yes");
      }
    }

    onAfterLayout() {
      if (this.getWidget() && this.getWidget().updateScrollersVisibility) {
        this.getWidget().updateScrollersVisibility();
      }
    }

    destroy() {
      if (this._afterLayoutHandler) {
        this._afterLayoutHandler();
      }
      super.destroy();
    }
  }

  cls.FolderController = FolderController;
  cls.ControllerFactory.register("Folder", cls.FolderController);
});
